import "./style/karta.scss";
import { IAddOrnamentRequest, ICintorinConfig, IEditOrnamentRequest, IOrnamentType } from "./common/interfaces";
import { createPopper, Instance } from "@popperjs/core";
import {register} from 'ol/proj/proj4';
import * as proj4x from 'proj4';
import { removeChildren } from "./common/utilities";
import { DECEASED_TAB_NO } from "./common/constants";
import { getLocalizedText } from "./common/translations";
import { attachChronicleEventHandlers, attachChroniclePickerEvents, loadOwnershipForm, switchChronicleContext } from "./kronika";
import { USER_CONTEXT_CHANGED_EVENT } from "./iam";
import { recalculateCardPosition } from "./page";

// zaregistrovanie JTSK projekcie
let proj4 = (proj4x as any).default; // workaround kvoli nekompatibilnym verziam proj4 a @types/proj4
proj4.defs("EPSG:5514", "+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=485,169.5,483.8,7.786,4.398,4.103,0 +units=m +no_defs");
register(proj4);

// deklarujem ako vyzera CintorinConfig objekt bez toho aby sa includol do kniznice
declare const CintorinConfig: ICintorinConfig;
declare var CintorinMapa: {
    selectGrave: (locationId: string, cintorinId: number) => void,
    refreshOrnaments: () => void
};

var popper: Instance;
var gpsPopper: Instance;
var currentCintorinId:number;

document.addEventListener("readystatechange", () => {
    if (document.readyState === 'complete') {
        window.addEventListener("resize", handleTabScroll);
        document.querySelector("#karta .nav-item:has([href='#platba'])")?.addEventListener("click", function () {
            if (document.getElementById("cardHId"))
                gtag("event", "paymentTabClicked", {});
        });
        document.querySelector("#karta .nav-item:has([href='#odkazy'])")?.addEventListener("click", function () {
            if (document.getElementById("cardHId"))
                gtag("event", "ornamentTabClicked", {});
        });
        document.querySelector("#karta .nav-item:has([href='#kronika'])")?.addEventListener("click", function () {
            if (document.getElementById("cardHId"))
                gtag("event", "chronicleTabClicked", {tabContext: "tab"});
        });
        attachCardEventHandlers();
        if (document.getElementById("cardHId")) {
            loadMessages(+(document.getElementById("cardHId") as HTMLInputElement).value, 0);
            loadOwnershipForm();
            if (document.getElementById("chronicleSelectedPerson") && document.getElementById("chronicleSelectedPerson").hasAttribute("data-deceased-id")) {
                switchChronicleContext(+document.getElementById("chronicleSelectedPerson").getAttribute("data-deceased-id"));
            }
            document.addEventListener(USER_CONTEXT_CHANGED_EVENT, (event:CustomEvent) => { 
                if (document.getElementById("chronicleSelectedPerson") && document.getElementById("chronicleSelectedPerson").hasAttribute("data-deceased-id")) {
                    switchChronicleContext(+document.getElementById("chronicleSelectedPerson").getAttribute("data-deceased-id"));
                }
            });
        }
        if (document.getElementById("cardCId")) {
            currentCintorinId = +(document.getElementById("cardCId") as HTMLInputElement).value;
            document.getElementById("showCemeteryDetails")?.addEventListener("click", function() { document.querySelector("#cintorinData .mobile-collapsible").classList.remove("collapsed"); });
        }
    }
});

export function updateCemeteryData(cid?: number) {
    if (currentCintorinId != cid) {
        if (cid) {
            fetch(CintorinConfig.baseUrl+"/api/htmlGetCemeteryCard.php",  {
                method: "POST",
                headers: new Headers({
                    'Content-Type': 'application/x-www-form-urlencoded'
                }),
                body: "cId="+encodeURIComponent(cid)
            }).then(response => {
                if (response.ok) {
                    return response.text();
                }
            }).then(htmlText => {
                if (document.getElementById("cintorinData")) {
                    if (htmlText) {
                        document.getElementById("cintorinData").innerHTML = htmlText;
                        document.getElementById("showCemeteryDetails")?.addEventListener("click", function() { document.querySelector("#cintorinData .mobile-collapsible").classList.remove("collapsed"); });
                    } else {
                        document.getElementById("cintorinData").innerHTML = "";
                    }
                }
            });
        } else if (document.getElementById("cintorinData")) {
            document.getElementById("cintorinData").innerHTML = "";
        }
        currentCintorinId = cid;
    }
}

export function updateGraveCardFromMap(hIdentifier: string, cId: number, selectedTabIndex: number):Promise<void> {
    if (document.getElementById("cardIdentifier") && (document.getElementById("cardIdentifier") as HTMLInputElement).value == hIdentifier) {
        selectTab(selectedTabIndex);
        return;
    }
    return requestCard("cId="+encodeURIComponent(cId)+"&locationIdentifier="+encodeURIComponent(hIdentifier), selectedTabIndex)
        .then(() => {
            if (document.getElementById("cardHId") && document.getElementById("karta")) {
                document.getElementById("karta").scrollIntoView({behavior: "smooth"});
            }
        });
}

export function updateGraveCard(hId: number, cId: number, selectedTabIndex?: number, zId?: number):Promise<void> {
    if (document.getElementById("cardHId") && +(document.getElementById("cardHId") as HTMLInputElement).value == hId) {
        selectTab(selectedTabIndex || DECEASED_TAB_NO);
        return Promise.resolve();
    }
    let zIdComponent = (zId) ? "&zId="+encodeURIComponent(zId) : ""
    return requestCard("cId="+encodeURIComponent(cId)+"&hId="+encodeURIComponent(hId)+zIdComponent, selectedTabIndex)
        .then(() => {
            if (document.getElementById("cardHId") && document.getElementById("karta")) {
                document.getElementById("karta").scrollIntoView({behavior: "smooth"});
            }
        });
}

export function loadMessages(hrobId :number, offset :number = 0) {
    fetch(CintorinConfig.baseUrl+"/api/htmlGetMessages.php",  {
        method: "POST",
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: "hId="+encodeURIComponent(hrobId)+"&offset="+encodeURIComponent(offset)
    })
    .then(response => {
        if (response.ok)
            return response.text();
    })
    .then(html => {
        let loadingDiv = document.getElementById("ornament-loading-div");
        if (html) {
            if (offset == 0) {
                removeChildren(document.getElementById("karta-odkazy"));
                document.getElementById("karta-odkazy").innerHTML = html;
                let reportButtons = document.getElementById("karta-odkazy").getElementsByClassName("report-button");
                for (let i=0; i<reportButtons.length; i++) {
                    reportButtons.item(i).addEventListener("click", reportMessage);
                }
            } else {
                if (loadingDiv && +loadingDiv.getAttribute("data-offset") == offset) {
                    loadingDiv.remove();
                    let container = document.createElement("div");
                    container.innerHTML = html;
                    let reportButtons = container.getElementsByClassName("report-button");
                    for (let i=0; i<reportButtons.length; i++) {
                        reportButtons.item(i).addEventListener("click", reportMessage);
                    }
                    while (container.children.length > 0) {
                        document.getElementById("karta-odkazy").append(container.children[0]);
                    }
                }
            }
            scrollHandler();
        } else if (loadingDiv) {
            loadingDiv.removeAttribute("data-loading");
        }
    });
}

export function selectTab(selectedIndex:number) {
    let tabs = document.querySelectorAll("#karta-tab-content>.tab-content>.tab-pane");
    for (let i=0; i<tabs.length; i++) {
        tabs.item(i).classList.remove("active");
    }
    tabs[selectedIndex].classList.add("active");
    let tabList = document.querySelectorAll("#karta .nav a.nav-link");
    for (let i=0; i<tabList.length; i++) {
        tabList.item(i).classList.remove("active");
    }
    tabList.item(selectedIndex).classList.add("active");    
}

function requestCard(requestBody: string, selectedTabIndex: number):Promise<void> {
    disableTabs();
    return fetch(CintorinConfig.baseUrl+"/api/htmlGetCard.php",  {
        method: "POST",
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: requestBody
    }).then(response => {
        if (response.ok) {
            return response.text();
        }
    }).then(htmlText => {
        if (document.getElementById("karta-tab-content") && htmlText) {
            document.getElementById("karta-tab-content").innerHTML = htmlText;
            // event handlery
            attachCardEventHandlers(selectedTabIndex);
            if (document.getElementById("cardHId")) {
                loadMessages(+(document.getElementById("cardHId") as HTMLInputElement).value, 0);
                loadOwnershipForm();
                if (document.getElementById("chronicleSelectedPerson") && document.getElementById("chronicleSelectedPerson").hasAttribute("data-deceased-id")) {
                    switchChronicleContext(+document.getElementById("chronicleSelectedPerson").getAttribute("data-deceased-id"));
                }
            }
            recalculateCardPosition();
        }
    });
}

function attachCardEventHandlers(selectedTabIndex?:number) {
    handleTabScroll();
    document.querySelector("#karta .nav")?.addEventListener("scroll", handleTabScroll);
    document.getElementById("tabNavArrowLeft")?.addEventListener("click", handleTabArrowClick);
    document.getElementById("tabNavArrowRight")?.addEventListener("click", handleTabArrowClick);

    document.getElementById("karta-hrob-cislo-selector")?.addEventListener("change", switchGrave);
    document.getElementById("previousGrave")?.addEventListener("click", selectPreviousGrave);
    document.getElementById("nextGrave")?.addEventListener("click", selectNextGrave);
    setUpPopover();
    document.getElementById("karta-tlac-qr")?.addEventListener("click", () => {printQrCode(false);});
    document.getElementById("karta-tlac-qr-demo")?.addEventListener("click", () => {printQrCode(true);});
    if (document.getElementById("cardHId")) {
        initializeOrnamentDropdownEvents();
        enableTabs();
        selectTab(selectedTabIndex || DECEASED_TAB_NO);
        let deceasedLinks = document.querySelectorAll("#zosnuly-zoznam span.fake-link");
        deceasedLinks.forEach(span => {
            span.addEventListener("click", handleShowDeceasedDetails);
        });
    }
    attachChroniclePickerEvents();
    attachChronicleEventHandlers();
}

function handleTabScroll() {
    let element = document.querySelector("#karta .nav");
    if (element) {
        document.getElementById("tabNavArrowLeft").style.display = (element.scrollLeft == 0) ? "none" : "";
        document.getElementById("tabNavArrowRight").style.display = (element.scrollWidth == element.scrollLeft + element.clientWidth) ? "none" : "";
    }
}

function handleTabArrowClick() {
    let amount = (this.id == "tabNavArrowLeft") ? -100 : 100;
    document.querySelector("#karta .nav").scrollBy({
        top: 0,
        left: amount,
        behavior: "smooth"
    });
}

function enableTabs() {
    let tabList = document.getElementById("karta").children[0];
    for (let i=0; i<tabList.children.length; i++) {
        tabList.children[i].children[0].classList.remove("disabled");
    }
}

function disableTabs() {
    let tabList = document.getElementById("karta").children[0];
    for (let i=0; i<tabList.children.length; i++) {
        tabList.children[i].children[0].classList.add("disabled");
    }
}

function initializeOrnamentDropdownEvents() {
    let elements = document.getElementById("ozdoby-selector").querySelectorAll("img");
    elements.forEach((item) => {
        item.addEventListener("click", function (ev:MouseEvent):any {
            let odkazyOrnamentTypeInput = document.getElementById("ornamentType") as HTMLInputElement;
            let previousType = odkazyOrnamentTypeInput.value;
            odkazyOrnamentTypeInput.value = this.getAttribute("data-ornament-type");
            if (previousType != odkazyOrnamentTypeInput.value) {
                addOrnament();
            }
        })
    });
    document.getElementById("postOrnament").addEventListener("click", function (ev) {
        ev.preventDefault();
        editOrnament();
    });
    document.getElementById("close-ornament-form").addEventListener("click",  function (ev) {
        document.getElementById("mapContainer").scrollIntoView({behavior: "smooth"});
        resetOrnamentForm();
    });    
}

function reportMessage() {
    let ornamentId = this.getAttribute("data-ornament-id");
    fetch(CintorinConfig.baseUrl+"/api/reportMessage.php", {
        method: "POST",
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: "oId="+encodeURIComponent(ornamentId)
    }).then(response => {
        if (response && response.ok) {
            alert(getLocalizedText("messageReported"));
        } else {
            alert(getLocalizedText("messageReportError"));
        }
    });
}

function printQrCode(isDemo:boolean) {
    let frameName :string = (isDemo ? "qr_kod_print_demo" : "qr_kod_print");
    for (let i=0; i < window.frames.length; i++) {
        let frame = window.frames[i];
        let name = "";
        try {
            name = frame.name;
        } catch {
            name = "";
        }
        if (frameName == name) {
            frame.focus();
            frame.print();
        }
    }
}

function setUpPopover() {
    if (document.getElementById("topRowShowMoreButton")) {
        document.getElementById("topRowShowMoreButton").addEventListener("click", toggleTopRowExpanded);
    }
    if (document.getElementById("copy-text-popover")) {
        document.getElementById("share-button")?.addEventListener("click", handleShareButtonClick);
        document.getElementById("copyTextInput")?.addEventListener("focusin", function () { (this as HTMLInputElement).select();});
        document.getElementById("gps-button")?.addEventListener("click", handleGpsButtonClick);
        document.getElementById("copy-text-button")?.addEventListener("click", copyTextToClipboard);
        document.getElementById("show-on-map-button")?.addEventListener("click", handleShowOnMapButtonClick);
    
        let owner = document.getElementById("share-button");
        popper = createPopper(owner, document.getElementById("copy-text-popover"), { 
            placement: "top",
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [0, 20]
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: document.getElementById("copy-text-arrow")
                    }
                },
                {
                    name: "flip"
                }
            ]
        });
        gpsPopper = createPopper(document.getElementById("gps-button"), document.getElementById("gps-popover"), { 
            placement: "top",
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [0, 20]
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: document.getElementById("gps-popover-arrow")
                    }
                },
                {
                    name: "flip"
                }
            ]
        });
        document.addEventListener("click", (event) => {
            let e = event.target as Node;
            if (document.getElementById("gps-button").contains(e)) {
                if (!document.getElementById("gps-popover").contains(e)) {
                    hidePopover();
                }
            } else if (document.getElementById("share-button").contains(e)) {
                if (!document.getElementById("copy-text-popover").contains(e)) {
                    hideGpsPopover();
                }
            } else if (!document.getElementById("karta").contains(e)) {
                hidePopover();
                hideGpsPopover();
            }
            if (!document.querySelector(".top-row-buttons").contains(e)) {
                document.querySelector(".top-row-buttons").removeAttribute("data-expanded");
            }
        });
    }
}

function toggleTopRowExpanded() {
    let buttonParent = document.querySelector(".top-row-buttons");
    if (buttonParent.hasAttribute("data-expanded")) {
        buttonParent.removeAttribute("data-expanded");
        hideGpsPopover();
        hidePopover();
    } else {
        buttonParent.setAttribute("data-expanded", "true");
    }
}

function handleGpsButtonClick(e:MouseEvent) {
    e.preventDefault();
    if (!document.getElementById("gps-popover").contains(e.target as Node)) {// toggle len ak klikam na button
        let popup = document.getElementById("gps-popover");
        if (popup.hasAttribute("data-show")) {
            popup.removeAttribute("data-show");
        } else {
            popup.setAttribute("data-show", "");
        }
    }
    gpsPopper.update();
}

function hideGpsPopover() {
    document.getElementById("gps-popover").removeAttribute("data-show");
    gpsPopper.update();
}

function handleShareButtonClick(e:MouseEvent) {
    e.preventDefault();
    if (this.classList.contains("disabled")) {
        return;
    }
    if (!document.getElementById("copy-text-popover").contains(e.target as Node)) { // toggle len ak klikam na button
        let sharePopper = document.getElementById("copy-text-popover");
        if (sharePopper.hasAttribute("data-show")) {
            sharePopper.removeAttribute("data-show");
        } else {
            sharePopper.setAttribute("data-show", "");
        }
    }
    (document.getElementById("copyTextInput") as HTMLInputElement).value = this.getAttribute("data-popup-text");
    if (navigator.clipboard) { //ak nefunguje SSL, navigator.clipboard je undefined a nebude fungovat kopirovanie, preto to radsej schovam
        document.getElementById("copy-text-button").style.display = "inline-block";
    } else {
        document.getElementById("copy-text-button").style.display = "none";
    }
    popper.update();
}

function hidePopover() {
    if (document.getElementById("copy-text-popover")) {
        document.getElementById("copy-text-popover").removeAttribute("data-show");
    }
}

function copyTextToClipboard() {
    let text = (document.getElementById("copyTextInput") as HTMLInputElement).value;
    navigator.clipboard.writeText(text);
}

function addOrnament() {
    if (document.getElementById("cardHId")) {
        let request:IAddOrnamentRequest = {
            hId: +(document.getElementById("cardHId") as HTMLInputElement).value,
            ornamentType: (document.getElementById("ornamentType") as HTMLInputElement).value as IOrnamentType
        };
        fetch(CintorinConfig.baseUrl+"/api/addMessage.php", {
            method: "POST",
            headers: new Headers({
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(request)
        }).then(response => {
            if (response.ok && response.status == 200) {
                return response.json();
            } else if (response.status == 403) {
                alert(getLocalizedText("addMessageForbidden"));
            } else {
                alert(getLocalizedText("addMessageError").replace("#", ""+response.status));
            }
        }).then(result => {
            if (result && result.inserted_id && result.inserted_id > 0) {
                resetOrnamentForm();
                if (result.messages_allowed) {
                    document.getElementById("ornament-type-label").classList.add("collapse");
                    document.getElementById("ozdoba-added").classList.remove("collapse");
                    document.getElementById("ozdoby-selector").querySelectorAll("img[data-ornament-type='"+(document.getElementById("ornamentType") as HTMLInputElement).value+"']")[0].classList.add("selected");
                    (document.getElementById("ornamentId") as HTMLInputElement).value = result.inserted_id;
                    document.getElementById("addOrnamentForm").getElementsByClassName("card-body")[0].classList.add("show");
                }
                loadMessages(request.hId, 0);
                CintorinMapa.refreshOrnaments();
                if (!result.messages_allowed) {
                    document.getElementById("mapContainer").scrollIntoView({behavior: "smooth"});
                }
            } else {
                let replacement = "";
                if (result && result.inserted_id) {
                    replacement = "id="+result.inserted_id;
                }
                alert(getLocalizedText("addMessageError").replace("#", replacement));
            }
        });    
    }
}

function editOrnament() {
    let request:IEditOrnamentRequest = {
        id: +(document.getElementById("ornamentId") as HTMLInputElement).value,
        author: (document.getElementById("messageAuthor") as HTMLInputElement).value,
        message: (document.getElementById("messageText") as HTMLInputElement).value
    };
    fetch(CintorinConfig.baseUrl+"/api/editMessage.php", {
        method: "POST",
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify(request)
    }).then(response => {
        if (response.ok && response.status == 200) {
            resetOrnamentForm();
            loadMessages(+(document.getElementById("cardHId") as HTMLInputElement).value, 0);
            CintorinMapa.refreshOrnaments();
            document.getElementById("mapContainer").scrollIntoView({behavior: "smooth"});
        } else if (response.status == 403) {
            alert(getLocalizedText("addMessageForbidden"));
        } else {
            alert(getLocalizedText("addMessageError").replace("#", ""+response.status));
        }
    });
}

function resetOrnamentForm() {
    (document.getElementById("ornamentId") as HTMLInputElement).value = "-1";
    (document.getElementById("messageAuthor") as HTMLInputElement).value = "";
    (document.getElementById("messageText") as HTMLInputElement).value = "";
    document.getElementById("ozdoba-added").classList.add("collapse");
    document.getElementById("ornament-type-label").classList.remove("collapse");
    document.getElementById("ozdoby-selector").querySelectorAll("img").forEach(i => {
        i.classList.remove("selected");
    });
    document.getElementById("addOrnamentForm").getElementsByClassName("card-body")[0].classList.remove("show");
}

function selectNextGrave() {
    let select = document.getElementById("karta-hrob-cislo-selector") as HTMLSelectElement;
    if (select) {
        let optionCount = select.options.length;
        if (select.selectedIndex < optionCount-1) {
            select.selectedIndex++;
        } else {
            select.selectedIndex = 0;
        }
    }
    switchGrave.bind(select)();
}

function selectPreviousGrave() {
    let select = document.getElementById("karta-hrob-cislo-selector") as HTMLSelectElement;
    if (select) {
        let optionCount = select.options.length;
        if (select.selectedIndex < 1) {
            select.selectedIndex = optionCount-1;
        } else {
            select.selectedIndex--;
        }
    }
    switchGrave.bind(select)();
}

function switchGrave() {
    let index = 0;
    let tabList = document.querySelector("#karta ul.nav-tabs");
    for (let i=0; i<tabList.children.length; i++) {
        if (tabList.children[i].children[0].classList.contains("active")){
            index = i;
            break;
        }
    }
    updateGraveCard(this.value, +(document.getElementById("cardCId") as HTMLInputElement).value, index);
}

function handleShowOnMapButtonClick(e:MouseEvent) {
    if (document.getElementById("cardIdentifier") && document.getElementById("cardCId")) {
        CintorinMapa.selectGrave((document.getElementById("cardIdentifier") as HTMLInputElement).value, +(document.getElementById("cardCId") as HTMLInputElement).value);
        document.getElementById("mapContainer").scrollIntoView({behavior: "smooth"});
    }
    e.preventDefault();
}

function handleShowDeceasedDetails() {
    if (this.getAttribute("data-deceased-id")) {
        let currentHid = (document.getElementById("cardHId") as HTMLInputElement)?.value;
        if (this.getAttribute("data-grave-id") && typeof(currentHid) !== "undefined" && this.getAttribute("data-grave-id") != currentHid) {
            updateGraveCard(this.getAttribute("data-grave-id"), currentCintorinId, DECEASED_TAB_NO, this.getAttribute("data-deceased-id"));
        } else {
            fetch(CintorinConfig.baseUrl+"/api/htmlGetDeceasedDetails.php", {
                method: "POST",
                headers: new Headers({
                    'Content-Type': 'application/x-www-form-urlencoded'
                }),
                body: "zId="+encodeURIComponent(this.getAttribute("data-deceased-id"))
            }).then(response => {
                if (response.ok) {
                    return response.text();
                }
            }).then(htmlText => {
                if (htmlText) {
                    document.querySelector("#zosnuli>div.row:first-child").innerHTML = htmlText;
                }
            });
        }
    }
}

function scrollHandler() {
    let loadingDiv = document.getElementById("ornament-loading-div") as HTMLDivElement;
    if (loadingDiv && loadingDiv.getAttribute("data-loading") !== "true") {
        let boundingRect = loadingDiv.getBoundingClientRect();
        let offset = loadingDiv.getAttribute("data-offset");
        if (document.getElementById("cardHId")) {
            let currentHid = (document.getElementById("cardHId") as HTMLInputElement).value;
            if (boundingRect.height > 0 && boundingRect.top <= window.innerHeight && offset && currentHid) {
                loadingDiv.setAttribute("data-loading", "true");
                loadMessages(+currentHid, +offset);
            }
        }
    }
}

window.addEventListener("scroll", scrollHandler);